import { type CurrencyCode } from '@/types/currency';

const formatToFullWithCurrencyPreset = (
  value: number,
  currency: CurrencyCode,
) => `${currency} ${Intl.NumberFormat('es-CL').format(value)}`;

export { formatToFullWithCurrencyPreset };
